import React from "react"
import styled from "styled-components"
import media from "../../styles/media"

const MapSection = styled.section`
  height: 100%;
  font-size: 20px;
  grid-column: 1 / -1;

  iframe {
    height: 100%;
    width: 100%;
  }

  ${media.tablet`
    grid-column: 5 / -1;
    align-self: start;
  `}
`

const ContactLeft = styled.section`
  font-family: StanleyRegular, serif;
  grid-column: 1 / span 3;
  align-self: start;

  div {
    a {
      text-decoration: none;
      color: ${props => props.theme.black};
    }
  }
`

const Title = styled.h3`
  font-weight: normal;
  font-family: neue-haas-grotesk-text, sans-serif;
  color: ${props => props.theme.lightGrey};
  font-size: 12px;
  letter-spacing: 1px;
  line-height: 19px;
  text-transform: uppercase;
  margin: 0 auto;

  ${media.tablet`
    font-size: 16.01px;
    letter-spacing: 1.33px;
    line-height: 30.68px;
  `}
`

const Info = styled.span`
  margin: 0 auto;
  font-size: 14px;

  ${media.tablet`
    font-size:24px;
  `}

  a {
    color: inherit;
    text-decoration: none;

    &:hover {
      color: ${props => props.theme.red};
    }
  }
`

const Address = styled.h2`
  font-weight: normal;
  margin: 0 auto;

  font-size: 24px;
  line-height: 36px;

  address {
    font-style: normal;
  }

  ${media.tablet`
    line-height:30px;
  `}
`

const InfoSection = styled.section`
  margin-bottom: 30px;
`

const AddressSection = styled.section`
  margin-bottom: 50px;
`

export const ContactInfo = ({
  officeAddress,
  phoneTitle,
  phoneInfo,
  faxTitle,
  faxInfo,
  inquiriesTitle,
  inquiriesInfo,
}) => {
  return (
    <>
      <ContactLeft aria-label="Columbia Artists Contact Info">
        <AddressSection aria-label="Address">
          <Address>
            <address>{officeAddress}</address>
          </Address>
        </AddressSection>
        <InfoSection>
          <Title>{phoneTitle}</Title>
          <Info>{phoneInfo}</Info>
        </InfoSection>
        <InfoSection>
          <Title>{faxTitle}</Title>
          <Info>{faxInfo}</Info>
        </InfoSection>
        <InfoSection>
          <Title>{inquiriesTitle}</Title>
          <Info>
            <a href="mailto:info@columbia-artists.com">{inquiriesInfo}</a>
          </Info>
        </InfoSection>
      </ContactLeft>
      <MapSection aria-label="Columbia Artists Location">
        <iframe
          title="demo"
          width="843"
          height="327"
          frameborder="0"
          src="https://www.google.com/maps/embed/v1/place?q=5%20Columbus%20Circle%20%40%205%20Columbia%20New%20York%2C%20NY%2010019-1412&key=AIzaSyAPJ3C0dMPQ1bjrUG-oa9ZSBCOnPY3OSnI"
          allowfullscreen
        />
      </MapSection>
    </>
  )
}
